export const dataSyncReducer = (
	state = {
		emc: null,
		thr: null,
		sup: null,
		wada: null,
		ingredient: null,
	},
	action
) => {
	switch (action.type) {
		case "DATA_SYNC_THR":
			return {
				...state,

				thr: action?.payload,
			};

		case "DATA_SYNC_EMC":
			return {
				...state,
				emc: action?.payload,
			};

		case "DATA_SYNC_SUB":
			return {
				...state,
				sup: action?.payload,
			};

		case "DATA_SYNC_WADA":
			return {
				...state,
				wada: action?.payload,
			};

		case "DATA_SYNC_INGREDIENT":
			return {
				...state,
				ingredient: action?.payload,
			};

		default:
			return state;
	}
};
